import {
  AlertColor,
  Box,
  Button,
  styled,
  TextField,
  Theme,
  useMediaQuery,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { globalTheme } from "../../../common/theme";
import createStyles from "@mui/styles/createStyles";
import axios from "axios";
import React from "react";
import { SnackBarMessage, SnackBarMessageProps } from "../../component/SnackBarMessage";
import Title from "../../component/Title";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { GridCellParams, GridColumns, GridToolbarContainer, GridValueSetterParams } from "@mui/x-data-grid";
import { Add } from "@mui/icons-material";
import { renewToken } from "../../../services/AuthService";
import { useConstructor } from "../../../common/UseConstructor";
import { BoxSize } from "./BoxSizeAccessories";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
  })
);

const StyledBox = styled(Box)(({ theme }) => ({
  height: "100%",
  width: "100%",
  "& .super-app-theme--cell": {
    backgroundColor: "rgba(41, 67, 63, 0.90)"
  },
}));

export function BoxSizeManagement() {
  const style = { ...useStyles(), ...globalTheme() };

  const tinyScreen = useMediaQuery('(max-width:1366px)');
  const smallScreen = useMediaQuery('(max-width:1920px)');
  const normalScreen = useMediaQuery('(max-width:2560px)');

  const [loading, setLoading] = React.useState<boolean>(false);

  const hasChanges = React.useRef<boolean>(false);

  const [gridData, setGridData] = React.useState<BoxSize[]>([]);

  //Grid columns
  const columns: GridColumns = [
    { field: 'boxSizeDescription', headerName: 'Box Size', flex: 1, type: 'string', editable: true,
        valueSetter: (param: GridValueSetterParams) => onValueChanged(param),
        cellClassName: (params: GridCellParams<number>) => {
          if (params.value == null) {
            return "";
          }

          if (params.row.id == 0)
            return "super-app-theme--cell";
          else
            return "";
      }
    }
  ];
  
  function onValueChanged(param: GridValueSetterParams) {
    let row: BoxSize = param.row;

    if (row.boxSizeDescription != param.value)
    {
      hasChanges.current = true;

      let oldDescription = row.boxSizeDescription;
      row.boxSizeDescription = param.value.slice(0, 20); 

      EditBoxSize(oldDescription, param.value.slice(0, 20));
    }

    return { ...param.row, row };
  }
  
  //Dialogs and snacks
  const [snackSettings, setSnackSettings] =
    React.useState<SnackBarMessageProps>({
      open: false,
      message: "",
      subMessage: "",
      severity: undefined,
      onClose: () => setSnackSettings({ open: false, message: "", subMessage: "", severity: undefined, onClose: () => {}})
    });

  function showSnackBar(message: string, subMessage: string, colour?: AlertColor) {
    setSnackSettings({
      open: true,
      message: message,
      subMessage: subMessage,
      severity: colour,
      onClose: () => setSnackSettings({ open: false, message: "", subMessage: "", severity: undefined, onClose: () => {}})
    });
  }

  function BoxSizeToolbar() {
    const [inputText, setInputText] = React.useState("");
    return (
      <GridToolbarContainer style={{ display: 'flex' }}>
        <TextField className={style.ModalContentFieldHalfWidth}
          style={{ minWidth: '100px', width: '100%' }}
          label="Box size description"
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          size="small"            
        />
        <div style={{ width: "10px", minWidth: "10px" }}></div>
        <Button style={{ width: tinyScreen ? "60px" : (smallScreen ? "75px" : "90px"), minWidth: tinyScreen ? "60px" : (smallScreen ? "75px" : "90px") }}
          variant="contained" size="small" color="secondary" startIcon={<Add />} onClick={() => NewBoxSize(inputText)}>Add</Button>
        <div style={{ width: "10px", minWidth: "10px" }}></div>
      </GridToolbarContainer>
    );
  }

  function NewBoxSize(boxSizeDescription: string) {
    if (gridData.findIndex(x => x.boxSizeDescription == boxSizeDescription) > -1)
    {
      showSnackBar("Box size already exists", "", "error");
      return;
    }
    if (boxSizeDescription=="")
    {
      showSnackBar("Please enter a description for the box size.", "", "error");
      return;
    }

    let newBoxSize: BoxSize = {
      boxSizeDescription: boxSizeDescription
    }

    axios.post<BoxSize>('Api/V1/BoxSize', newBoxSize).then(
      (result) => {
        let temp = [...gridData];
        temp.unshift(result.data);
        setGridData(temp);
        hasChanges.current = false;
        showSnackBar("Box size created successfully.", "", "success");
      },
      (error) => {
        showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
      }
    );
  }

  function EditBoxSize(oldDescription: string, newDescription: string) {
    if (newDescription=="")
    {
      showSnackBar("Please enter a description for the box size.", "", "error");
    }

    axios.put<BoxSize>('Api/V1/BoxSize', {}, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      params: {
        'oldBoxSize': oldDescription,
        'newBoxSize': newDescription
      }
    }).then(
      (result) => {
        if (result.data.boxSizeDescription==oldDescription)
        {
          showSnackBar("Box size already exists.", "", "error");
          let tempGridData = [...gridData];
          let index = tempGridData.findIndex(x => x.boxSizeDescription == newDescription);
          let boxSize = tempGridData[index];
          boxSize.boxSizeDescription = oldDescription;
          tempGridData[index] = boxSize;
          setGridData(tempGridData);
        }
        else
        {
          hasChanges.current = false;
          showSnackBar("Box size updated successfully.", "", "success");
        }
      },
      (error) => {
        showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
      }
    );
  }

  function SearchBoxSize() {
    setLoading(true);

    axios.get<BoxSize[]>('Api/V1/BoxSize', {
      headers: {
        'Content-Encoding': 'gzip'
      }
    })
      .then((result) => {
        setGridData(result.data)
        setLoading(false);
      },
        (error) => {
          setGridData([]);
          setLoading(false);
          console.log(error);
          showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
        }
      )
      .catch((error) => {
        setLoading(false);
        console.log(error);
        showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
      });
  }

  useConstructor(() => Initialise())
  function Initialise() {
    renewToken();
    
    hasChanges.current = false;
    SearchBoxSize();
  }

  return (
      <div className={style.PageMain}>
          <Title pageTitle="Box Size Management" />
          <div className={style.PageContent}>
            <div className={style.ModalContent}>
              <div className={style.PageFieldsFullHeight}>
                <div className={style.ModalContentFieldHalfWidth} style={{minWidth: 300}}>
                  <StyledBox>
                    <DataGridPro
                      getRowId={(row) => row.boxSizeDescription}
                      rows={gridData}
                      columns={columns}
                      loading={loading}
                      components={{
                        Toolbar: BoxSizeToolbar
                      }}
                      rowHeight={tinyScreen ? 20 : (smallScreen ? 24 : 28)}
                    />
                  </StyledBox>
                </div>
              </div>
            </div>
          </div>

        <SnackBarMessage {...snackSettings} />
      </div>
  );


}

